import React from "react";
import { ShinyText } from "./Home";
import { useInView } from "react-intersection-observer";
import { DemoButton } from "../../component/DemoButton/DemoButton";

const AIPoweredSection = () => {
  const { ref: videoRef, inView: videoView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: buttonRef, inView: buttonView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <div className="flex md:flex-row flex-col-reverse items-center md:gap-2 gap-10 xl:pt-10 lg:pt-8 md:pt-6 xlp-10 m lg:pb-8 md:pb-6d:pb-10 lg:px-10 md:px-6 z-[5] bg-white ">
      <div className=" flex-1 flex justify-center items-center">
        <video
          ref={videoRef}
          className={`lg:w-[85%] md:w-[90%] w-full xl:rounded-3xl rounded-2xl ${
            videoView ? `animate-slideUp z-[3] anim-preserve` : "opacity-0 z-0"
          }`}
          src="https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/Ai%20language.mp4"
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          preload="metadata"
        />
      </div>
      <div className=" flex-1 flex flex-col md:items-start items-center xl:gap-5 lg:gap-4 gap-3">
        <div
          ref={headingRef}
          className={` ${
            headingView
              ? `animate-slideUp z-[3] anim-preserve`
              : "opacity-0 z-0"
          } xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] md:text-left text-center leading-tight tracking-tighter  font-jakarta font-bold`}
        >
          <ShinyText
            text="AI-Powered "
            speed={5}
            className="custom-class text-wrap"
          />
          Language Detection
        </div>
        <div className=" xl:text-[1.438rem] z-[4] relative bg-white lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] md:text-left text-center leading-snug text-[#00000099] font-inter ">
          Powered with AI, Zero Typing will automatically detect any language
          you speak in and give you a polished output depending on the way you
          have configured your application. Switch between languages without any
          hassle, just speak!
        </div>
        <DemoButton
          text="Try ZeroTyping AI"
          ref={buttonRef}
          view={buttonView}
        />
      </div>
    </div>
  );
};

export default AIPoweredSection;
